<template>
  <div
    class="input-field"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
    ref="auto"
    v-show="viewConditions"
  >
	
    <div :class="`${name}_select select-labels`" v-if="showLabel">{{ label }}</div>
		
      <span
      class="helper-text"
      :data-error="error"
      data-success="Correct"
      v-if="showHelperText"
      >{{ helperText }}</span>
    <i class="material-icons prefix" v-if="icon">{{ icon }}</i>

    <input
      v-if="type === 'autocomplete'"
      :id="`${name}_${type}`"
      type="text"
      v-model="fieldValue"
      :class="`auto-complete`"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      
    />
    <!-- :autocomplete="autoComplete ? 'on' : 'off'" -->
     <div class="label"
      v-if="showLabel && type === 'textarea'">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "autoComplete",
  props: {
    viewConditions:{
      required: false,
    },
    minValue:{
      type: [Number],
      default: 0,
    },
    value: {
      type: [String, Number],
    },
    name: {
      type: String,
      required: true,
    },
    viewConditions: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    fieldType: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    showHelperText: {
      type: Boolean,
      default: () => true,
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
		options:{
			type: Object,

		},
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
			instance: null,
      isTyping: false,
      showPassword: false,
      fieldValue: this.value,
    };
  },
  mounted() {
		
    //this.addPlaceholder()
    this.addToGroup()
		setTimeout(() => {
			this.$_initAutoComplete()
		}, 100);
  },
  watch: {
    fieldValue: function(nV) {
      // this.allowOnlyNumber();
    
    if (this.fieldValue !== 'number') this.updateValue()
      if(this.type === 'number' && parseFloat(nV) < 0) {
        setTimeout(() => {
          this.fieldValue = ''
        }, 300);
      } else {
       this.updateValue()
      }
    },
  },
  computed: {
    displayError() {
      if (this.isTyping) {
        if (this.hasError && this.error) {
          return "invalid";
        } else {
          return "valid";
        }
      }
    },
  },
  methods: {
    $_showPassword () {
      this.showPassword 
      ? this.showPassword = false 
      : this.showPassword = true
    },
    $_initAutoComplete () {
			let element = document.querySelectorAll('.auto-complete')
    this.instance = M.Autocomplete.init(element, {
      // specify options here
      data: this.options,
				onAutocomplete:(e) =>{
					this.fieldValue = e
				//	console.log(e)
			}
			
    });
		},
 addToGroup() {
      if (this.groupTag) {
        const groupId = `#${this.groupTag}`;
        const contentContainerId = `#${this.groupTag}_content`;
        // console.log(`${this.name} => belongs to ${this.groupTag} group`);

        const group = document.querySelector(groupId);

        const contentContainer = document.querySelector(contentContainerId);

        const groupItem = this.$refs.auto;

        if (contentContainer) {
          contentContainer.appendChild(groupItem);
        } else {
          group.appendChild(groupItem);
        }
      }
    },
    addPlaceholder() {
      if (this.placeholder && this.type !== "textarea") {
        const el = this.$el.querySelector(`#${this.name}_${this.type}`);
        //console.log(el)
        el.placeholder = this.placeholder;
      }
    },
    allowOnlyNumber() {
      if (this.type === "number") {
        this.fieldValue = this.fieldValue.replace(/[^0-9]/g, "");
      }
    },
    updateValue(event) {
      this.isTyping = true;
      // console.log(error, hasError);
      this.$emit("update", this.fieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.show-password {
  position: absolute;
  right: 6px;
  top: 6px; 
}
 .select-labels {
    font-size: 20px;
    margin-bottom: 12px;
  }
.helper-text {
  margin: 0 0 12px 0px;
  font-size: 15px;
}
</style>
